import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { getPageSOBP, InkStorage, InkStorageEventName, makeNPageIdStr } from "../../common";
export default function PageSelector(props) {
    // const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [pageInfos, setPageInfos] = useState(InkStorage.getInstance().getPageList());
    const [activePage, setActivePage] = useState(props.activePage);
    useEffect(() => {
        const is = InkStorage.getInstance();
        is.addEventListener(InkStorageEventName.ON_PAGE_ADDED, onPagesChanged, undefined);
        return () => {
            const is = InkStorage.getInstance();
            is.removeEventListener(InkStorageEventName.ON_PAGE_ADDED, onPagesChanged);
        };
    }, []);
    useEffect(() => {
        setActivePage(props.activePage);
        const is = InkStorage.getInstance();
        setPageInfos(is.getPageList());
    }, [props.activePage]);
    const onPagesChanged = () => {
        const is = InkStorage.getInstance();
        setPageInfos(is.getPageList());
    };
    const handlePageSelected = (e) => {
        const pageId = e.target.value;
        const pageInfo = getPageSOBP(pageId);
        setActivePage(pageInfo);
        if (props.changePageFn) {
            props.changePageFn(pageInfo);
        }
    };
    const pageOptions = pageInfos ? pageInfos.map((pageInfo, index) => {
        const pageId = makeNPageIdStr(pageInfo);
        const selectedPageId = makeNPageIdStr(activePage);
        if (selectedPageId === pageId)
            return (_jsx("option", Object.assign({ value: pageId, selected: true }, { children: pageId }), `${pageId}-${index}`));
        else
            return (_jsx("option", Object.assign({ value: pageId }, { children: pageId }), `${pageId}-${index}`));
    }) : () => { return (_jsx(_Fragment, {})); };
    return (_jsx(React.Fragment, { children: _jsx("ul", Object.assign({ id: "pages" }, { children: _jsx("label", { children: _jsx("select", Object.assign({ name: "activePage", id: "pages", onChange: handlePageSelected }, { children: pageOptions })) }) })) }));
}
//# sourceMappingURL=PageSelector.js.map